import { withViewModel } from '../../../../../infrastructure/components/with-view-model';
import { ConnectionTemplatesFormVM } from '../connection-template-form.viewmodel';
import ConnectionTemplateConnectionGroupPresentation from './connection-template-connection-groups.presentation';
import ConnectionTemplateConnectionGroupVM from './connection-template-connection-groups.viewmodel';

interface IConnectionTemplateConnectionGroupList {
    vm: ConnectionTemplatesFormVM;
};

const ConnectionTemplateConnectionGroupList = withViewModel(
    ConnectionTemplateConnectionGroupPresentation,
    (props: IConnectionTemplateConnectionGroupList) => {
        const {
            vm
        } = props;
        const connectionTemplateConnectionGroupVM = new ConnectionTemplateConnectionGroupVM(
            vm
        );
        return connectionTemplateConnectionGroupVM;
    }
);

export default ConnectionTemplateConnectionGroupList;